<template>
	<div id="app">
		<Loading v-show="loading" />
		<keep-alive :exclude="['Generate', 'Result']">
			<router-view :key="$route.path" />
		</keep-alive>
	</div>
</template>

<script>
import '@/css/main.scss'
import '@/css/el.css'
import Loading from './components/Loading.vue'

export default {
	name: 'App',
	components: {
		Loading,
	},
	metaInfo() {
		const titleTemplate = "Transform Your Ideas into Stunning Visuals with AI"
		const ogTitle = this.domainConfig.webTitle
		const ogDescription = `Discover the power of AI with ${this.domainConfig.webUrl}. Create stunning images effortlessly with our cutting-edge technology.`

		return {
			titleTemplate: '%s | ' + titleTemplate,
			meta: [
				{
					property: 'og:title',
					content: ogTitle,
				},
				{
					property: 'og:description',
					content: ogDescription,
				},
			],
		}
	},
	created() {
		let debug = this.$global.GetQueryString('db')
		if (debug) {
			this.$store.commit('setDebug', true)
		}

		// 开发环境下的默认值
		if (Object.keys(this.domainConfig).length === 0) {
			console.log('🚀🚀🚀 this.host: ', this.host)
			if (!this.host) {
				this.$store.state.host = 'pixel2magic.com'
			}
			this.$store.commit('setDomain', require('@/utils/config/domainConfig.json')[this.host] || {})
			this.$store.commit('setAdsense', require('@/utils/config/domainConfig.json')[this.host]?.adsense || {})

			console.log('🚀🚀🚀 domainConfig: ', this.$store.state.domainConfig)
		}
	},
	async beforeMount() {
		this.getUserInfo()
		const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
		if (flag) {
			this.$store.state.deviceType = 'mobile'
		} else {
			this.$store.state.deviceType = 'desktop'
		}
	},
}
</script>
